// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"721bed86","239":"38054081","732":"e74264b2"}[chunkId] + ".chunk.js";
};